<template>
    <transition name="modal-fade">
      <div class="modal-overlay-gcn" v-if="show" @click.self="closeModal">
        <div class="modal-container-gcn" :class="modalSizeClass">
          <div class="modal-header-gcn">
            <h3><slot name="header">{{ title }}</slot></h3>
            <button class="modal-close-btnGcn" @click="closeModal">×</button>
          </div>
  
          <div class="modal-body-gcn">
            <slot name="body"></slot>
          </div>
  
          <div class="modal-footer-gcn">
            <slot name="footer">
              <!-- Default footer button -->
              <button class="btnGcn btnGcn-secondary" @click="closeModal">Close</button>
            </slot>
          </div>
        </div>
      </div>
    </transition>
  </template>
  
  <script>
  export default {
    name: 'Modal',
    props: {
      show: {
        type: Boolean,
        required: true,
      },
      title: {
        type: String,
        default: 'Modal Title',
      },
      size: {
        type: String, // e.g., 'sm', 'lg', 'xl' or default
        default: '',
      }
    },
    computed: {
        modalSizeClass() {
            return this.size ? `modal-${this.size}` : '';
        }
    },
    methods: {
      closeModal() {
        this.$emit('close');
      },
    },
    watch: {
        // Optional: Add/remove body class to prevent scrolling when modal is open
        show(newVal) {
            if (newVal) {
                document.body.style.overflow = 'hidden';
            } else {
                // Ensure we don't remove the style if another modal is still open
                // This simple version assumes only one modal system controls overflow
                document.body.style.overflow = '';
            }
        }
    },
    // Optional: Clean up body style if component is destroyed while modal is open
    beforeDestroy() {
        if (this.show) {
             document.body.style.overflow = '';
        }
    }
  };
  </script>
  
  <style scoped>
  /* Scoped styles specific to the modal transition */
  .modal-fade-enter-active, .modal-fade-leave-active {
    transition: opacity 0.3s ease;
  }
  .modal-fade-enter, .modal-fade-leave-to /* .modal-fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  
  .modal-fade-enter-active .modal-container-gcn,
  .modal-fade-leave-active .modal-container-gcn {
      transition: transform 0.3s ease;
  }
  .modal-fade-enter .modal-container-gcn,
  .modal-fade-leave-to .modal-container-gcn {
      transform: translateY(-30px);
  }
  
  /* Import general modal styles if not globally included */
  /* @import '@/assets/css/styles.css'; */
  /* If styles.css is loaded globally (e.g., in main.js), this import isn't needed */
  </style>